import { Theme } from './types';
import { themeDefaults } from './themeDefaults';

export const brightLightTheme: Theme = {
  ...themeDefaults,
  palette: {
    bodyBackground: 'white',
    bodyText: 'black',
    text: {
      primary: 'black',
      secondary: '#818c99',
    },
    statusBar: {
      default: {
        color: '#fff',
        style: 'dark',
      },
    },
  },
};
